import React, { Fragment, Component } from "react";
import NavBar from "../common/forms/NavbarCopy";
import { Row, Col, Container, Button } from "react-bootstrap";

import { AddNotification } from "../Methods/Notificaition.jsx";
import { BsArrowLeft } from "react-icons/bs";
import { subDirectory } from "../../config.json";
import "../../styles/BoatBookingHistory.scss";
import qrcode from "../../images/boat/qrcode.png";
import { getbookinghistory, PublicOthersBookedHistory } from "../../services/bookinghistoryService";
import { getLocalStorageValues } from "../../services/boat";
import { designUrl } from "../../config.json";
import { SkBookingHistoryCard } from "../common/skeleton/subcatCardSkeleton";

import { compareAsc, format, isBefore, isPast } from "date-fns";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import CryptoJS from 'crypto-js';
class BoatBookingHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      varient: "",
      message: "",
      isTicket: false,
      BookingHistoryData: [],
      isBookingHistory: false,
      isBookingHistoryLoading: true,
      OtherBookingHistoryData: [],
      OtherLoading: true,
    };
  }

  componentDidMount = async () => {
    await this.BookingHistory();
    await this.OtherServiceBookingHistory();
  };

  BookingHistory = async () => {
    await this.setState({ isBookingHistoryLoading: true });
    let data = {
      UserId: await getLocalStorageValues("UserId"),
    };

    const res = await getbookinghistory(data);
    console.log(res);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({
          BookingHistoryData: res.data.Response,

          isBookingHistory: true,
          isBookingHistoryLoading: false,
        });
      } else {
        this.setState({ BookingHistoryData: [], isBookingHistory: false, isBookingHistoryLoading: false });
      }
    } else {
      this.setState({ BookingHistoryData: [], isBookingHistory: false, isBookingHistoryLoading: false });
    }
  };

  OtherServiceBookingHistory = async () => {
    let data = {
      UserId: await getLocalStorageValues("UserId"),
    };

    const res = await PublicOthersBookedHistory(data);
    console.log(res);
    if (res.data.StatusCode === 1) {
      if (res.data.Response?.length > 0) {
        this.setState({
          OtherBookingHistoryData: res.data.Response,
          OtherLoading: false,
        });
      } else {
        this.setState({ OherBookingHistoryData: [], OtherLoading: false });
      }
    } else {
      this.setState({ OtherBookingHistoryData: [], OtherLoading: false });
    }
  };
  // onTicket = (bookings) => {
  //   window.location.replace(`${subDirectory}/booking-receipt?BoatHouseId=${bookings.BoatHouseId}&BookingId=${bookings.BookingId}&BookingDate=${bookings.BookingDate}&BookingType=${bookings.BookingStatus}`);
  // };

  encryptedValuesFun (value)  {
	  const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString();
	 
    if (encryptedValue) {
      return encryptedValue.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe encoding
    }
	}
  onTicket = (bookings) => {
    const BoatHouseValue = this.encryptedValuesFun(bookings.BoatHouseId);
    const BookingValue = this.encryptedValuesFun(bookings.BookingId);
    const DateValue = this.encryptedValuesFun(bookings.BookingDate);
    const BookingTypeValue = this.encryptedValuesFun(bookings.BookingStatus);
    console.log("onTicket",BoatHouseValue,BookingValue,DateValue,BookingTypeValue)
    window.location.replace(`${subDirectory}/booking-receipt?BHId=${BoatHouseValue}&BId=${BookingValue}&BD=${DateValue}&BT=${BookingTypeValue}`);

    
  };
  onReceipt = (bookings) => {
    const BoatHouseValue = this.encryptedValuesFun(bookings.BoatHouseId);
    const BookingValue = this.encryptedValuesFun(bookings.BookingId);
    const DateValue = this.encryptedValuesFun(bookings.BookingDate);
    window.location.replace(`${subDirectory}/trip-receipt?BHId=${BoatHouseValue}&BId=${BookingValue}&BD=${DateValue}`);

    
  };

  onBoardingPass = (bookings) => {
    this.props.history.push({
      pathname: `${subDirectory}/boardingPass`,
      state: {
        bookings: bookings,
        BoatHouseId: bookings.BoatHouseId,
        BookingId: bookings.BookingId,
      },
    });
  };
  onRescheduling = (bookings) => {
    this.props.history.push({
      pathname: `${subDirectory}/Reschedule`,
      state: {
        bookings: bookings,
        BoatHouseId: bookings.BoatHouseId,
        BookingId: bookings.BookingId,
      },
    });
  };
  onCancel = (bookings) => {
    this.props.history.push({
      pathname: `${subDirectory}/boatBookingCancellation`,
      state: {
        bookings: bookings,
        BoatHouseId: bookings.BoatHouseId,
        BookingId: bookings.BookingId,
      },
    });
  };
  onBoardingView = (bookings) => {
    this.props.history.push({
      pathname: `${subDirectory}/boardingPassTicket`,
      state: {
        bookings: bookings,
        BoatHouseId: bookings.BoatHouseId,
        BookingId: bookings.BookingId,
      },
    });
  };

  frameLoadAllBookings = () => {
    const allBookings = this.state.BookingHistoryData;

    return allBookings.map((allBookings) => (
      <div className="hotel_webhis d-flex justify-content-center container my-4 mx-auto ">
        <Row className="px-3 w-100">
          <Col md={12}>
            <Row>
              <Col md={6} className="mb-1">
                <div class="webh-name text-left">{allBookings.BoatHouseName}</div>
                <div className="receiptdisplay">
                  <div className="receiptbid"> Booking Id </div>
                  <div>:</div>
                  <div className="receiptvalue">{allBookings.BookingId} </div>
                </div>
                <div className="receiptdisplay">
                  <div className="receiptbid"> Booking Date </div>
                  <div className="">:</div>
                  <div className="receiptvalue"> {allBookings.BookingDate} </div>
                </div>
                <div className="receiptdisplay">
                  <div className="receiptbid"> Trip Status </div>
                  <div className="">:</div>
                  <div className="receiptvalue"> {allBookings.TripStartStatus}</div>
                </div>
                {/* <div className="receiptdisplay">
                  <div className="receiptbid"> Transaction No </div>
                  <div className="">:</div>
                  <div className="receiptvalue"> {allBookings.TransactionNo}</div>
                </div> */}
              </Col>
              <Col md={6} className="table-res">
                <div className="hisdiv">
                  <label class="pricevalue  fs-h">Price :</label>
                  <label>
                    <span class="pricevalue fs-h"> ₹ {allBookings.Amount}</span>
                  </label>
                </div>
                {/* <Row>
                    <div className="mt-5"> 
                      
                        <div className="mt-5 hisdiv" > <Button className="btn btn-info  mr-3 btn btn-secondary res web-btns" onClick={() => this.onTicket(allBookings)}>
                          View Ticket
                    </Button>
                        </div>

                      
                    </div>

                </Row> */}
              </Col>
            </Row>

            <Row className="rowmargin">
              <div className="d-flex mobdivdd justify-content-end">
                {/* <Col md={2}> */}
                <div className="hisdiv1 mr-3">
                  {allBookings.TripStartStatus === "Not Started" && allBookings.BookingStatus !== "C" &&
                    <Button className="btn btn-info btn btn-secondary res web-btns" onClick={() => this.onTicket(allBookings)}>
                      View Ticket
                    </Button>
                  }
                </div>
               
                  {allBookings.TripStartStatus === "Trip Completed" &&
                   <div className="hisdiv1 mr-3">
                      <Button className="btn btn-info btn btn-secondary res web-btns" onClick={() => this.onReceipt(allBookings)}>
                        View Receipt
                      </Button>
                    </div>
                  }
                
                {/* </Col> */}
                {/* <Col md={5}>  */}

                {compareAsc(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00")) != "-1" && allBookings.BoardingPassStatus === "Generated" && allBookings.TripStartStatus === "Not Started" && allBookings.BookingStatus !== "C" && (
                  <div className="hisdiv1 mr-3">
                    <Button className="btn btn-primary btn btn-secondary res web-btns" onClick={() => this.onBoardingView(allBookings)}>
                      View Boarding Pass
                    </Button>
                  </div>
                )}
                {console.log(allBookings.BookingDate, allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2], new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), isPast(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2])), new Date(), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00"), compareAsc(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00")))}
                {/*changeBooking date format dd/mm/yyyy to mm/dd/yyyy , time 00.00.00 and compareAsc is for compare today and booked date */}
                {compareAsc(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00")) != "-1" && allBookings.BoardingPassStatus === "Not Generated" && allBookings.TripStartStatus === "Not Started" && allBookings.BookingStatus !== "C" && (
                  <div className="hisdiv1 mr-3">
                    <Button className="btn btn-success btn btn-secondary res web-btns" onClick={() => this.onBoardingPass(allBookings)}>
                      Generete Boarding Pass
                    </Button>
                  </div>
                )}

                {compareAsc(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00")) != "-1" && allBookings.TripStartStatus === "Not Started" && allBookings.BoardingPassStatus === "Not Generated" && allBookings.BookingStatus !== "C" && (
                  <div className="hisdiv1 mr-3">
                    {" "}
                    <Button className="btn btn-warning btn btn-secondary res web-btns" onClick={() => this.onRescheduling(allBookings)}>
                      Rescheduling
                    </Button>
                  </div>
                )}
                {allBookings.BookingStatus === "R" && <div className="hisdiv1 mr-3 divcolorr">Rescheduled</div>}

                {compareAsc(new Date(allBookings.BookingDate.split("/")[1] + "/" + allBookings.BookingDate.split("/")[0] + "/" + allBookings.BookingDate.split("/")[2]), new Date(format(new Date(), "MM/dd/yyyy") + " " + "00:00:00")) != "-1" && allBookings.TripStartStatus === "Not Started" && allBookings.BoardingPassStatus === "Not Generated" && allBookings.BookingStatus !== "C" && (
                  <div className="hisdiv1 mr-3">
                    <Button className="btn btn-danger btn btn-secondary res web-btns" onClick={() => this.onCancel(allBookings)}>
                      Cancel
                    </Button>
                  </div>
                )}
                {allBookings.TripStartStatus === "Not Started" && allBookings.BookingStatus === "C" && <div className="hisdiv1 mr-3 divcolorc">Cancelled</div>}
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    ));
  };
  frameLoadOtherServiceBookings = () => {
    const allBookings = this.state.OtherBookingHistoryData;

    return allBookings.map((allBookings) => (
      <div className="hotel_webhis d-flex justify-content-center container my-4 mx-auto ">
        <Row className="px-3 w-100">
          <Col md={12}>
            <Row>
              <Col md={6} className="mb-1">
                <div class="webh-name text-left">{allBookings.BoatHouseName}</div>
                <div className="receiptdisplay">
                  <div className="receiptbid"> Booking Id </div>
                  <div>:</div>
                  <div className="receiptvalue">{allBookings.BookingId} </div>
                </div>
                <div className="receiptdisplay">
                  <div className="receiptbid"> Booking Date </div>
                  <div className="">:</div>
                  <div className="receiptvalue"> {allBookings.BookingDate} </div>
                </div>
                {/* <div className="receiptdisplay">
                  <div className="receiptbid"> Transaction No </div>
                  <div className="">:</div>
                  <div className="receiptvalue"> {allBookings.TransactionNo}</div>
                </div> */}
              </Col>
              <Col md={6} className="table-res">
                <div className="hisdiv">
                  <label class="pricevalue  fs-h">Price :</label>
                  <label>
                    <span class="pricevalue fs-h"> ₹ {allBookings.Amount}</span>
                  </label>
                </div>
                {/* <Row>
                    <div className="mt-5"> 
                      
                        <div className="mt-5 hisdiv" > <Button className="btn btn-info  mr-3 btn btn-secondary res web-btns" onClick={() => this.onTicket(allBookings)}>
                          View Ticket
                    </Button>
                        </div>

                      
                    </div>

                </Row> */}
              </Col>
            </Row>

            <Row className="rowmargin">
              <div className="d-flex mobdivdd justify-content-end">
                {/* <Col md={2}> */}
                <div className="hisdiv1 mr-3">
                  {" "}
                  <Button className="btn btn-info btn btn-secondary res web-btns" onClick={() => this.onTicket(allBookings)}>
                    View Ticket
                  </Button>
                </div>
                {/* </Col> */}
                {/* <Col md={5}>  */}
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    ));
  };
  render() {
    const { isBookingHistory, isBookingHistoryLoading, OtherLoading } = this.state;
    return (
      <Fragment>
        {/* <Loader fullPage loading={this.state.loading} /> */}
        <AddNotification visible={false} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <div class="webCheckIn">
          <NavBar {...this.props} />
          <Container fluid className="webCheckIn-con">
            <div className="cancelscroll">
              <Row className="pt-3 mb-3">
                <div className="d-flex mx-auto  " style={{ width: "90%" }}>
                  {/* <div className="d-flex align-items-center  initialpage" style={{ fontSize: "16px", color: "white" }}>

                    <BsArrowLeft className="mr-2" />
                    Back to Home
                  </div> */}
                  <div className="webcheck-header d-flex justify-content-center">BOOKING HISTORY</div>
                </div>
                {/* </Col> */}
              </Row>
              <div className="all-history-container">
                <Tabs>
                  <TabList>
                    <Tab>Boating</Tab>
                    <Tab>Other Facilities</Tab>
                  </TabList>

                  <TabPanel>
                    <>
                      {isBookingHistoryLoading && (
                        <div className="hotel_webhis d-flex justify-content-center container my-4 mx-auto ">
                          {" "}
                          <SkBookingHistoryCard viewBox="0 0 700 300" />
                        </div>
                      )}
                      {!isBookingHistoryLoading && isBookingHistory && <div>{this.frameLoadAllBookings()}</div>}
                      {!isBookingHistoryLoading && !isBookingHistory && (
                        <div className="bbh">
                          <div className=" bbhnodata justify-content-center">No data found</div>
                        </div>
                      )}
                    </>
                  </TabPanel>
                  <TabPanel>
                    <>
                      {OtherLoading && (
                        <div className="hotel_webhis d-flex justify-content-center container my-4 mx-auto ">
                          {" "}
                          <SkBookingHistoryCard viewBox="0 0 700 300" />
                        </div>
                      )}

                      {!OtherLoading && this.state.OtherBookingHistoryData.length > 0 && <div>{this.frameLoadOtherServiceBookings()}</div>}
                    </>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </Container>
        </div>
      </Fragment>
    );
  }
}
export default BoatBookingHistory;
